import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@chakra-ui/react';
import { RevealGroup, RevealItem } from '../motion';
import PersonCard from './PersonCard';
import ProfileDrawer from './ProfileDrawer';

export const slugOf = (member) =>
  (member.name || member.title || '')
    .toLowerCase()
    .replace(/,.*$/, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

// A grid of portrait cards that open one shared profile panel.
//
// The open profile is mirrored in the URL hash (/board#vijay-sudheendra), so
// a link to one person opens straight to their bio.
const Roster = ({ people, columns = { base: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }, gap = { base: 6, md: 8 } }) => {
  const [openSlug, setOpenSlug] = useState(null);

  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.slice(1));
    if (hash && people.some((p) => slugOf(p) === hash)) setOpenSlug(hash);
  }, [people]);

  const open = useCallback((member) => {
    const slug = slugOf(member);
    setOpenSlug(slug);
    window.history.replaceState(null, '', `#${slug}`);
  }, []);

  const close = useCallback(() => {
    setOpenSlug(null);
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }, []);

  const index = people.findIndex((p) => slugOf(p) === openSlug);

  return (
    <>
      <RevealGroup>
        <Grid templateColumns={columns} gap={gap} justifyContent="center">
          {people.map((member) => (
            <RevealItem key={slugOf(member)} h="100%" id={slugOf(member)} scrollMarginTop="140px">
              <PersonCard member={member} onOpen={() => open(member)} />
            </RevealItem>
          ))}
        </Grid>
      </RevealGroup>

      <ProfileDrawer
        member={index >= 0 ? people[index] : null}
        prev={index > 0 ? people[index - 1] : null}
        next={index >= 0 && index < people.length - 1 ? people[index + 1] : null}
        onClose={close}
        onGo={open}
      />
    </>
  );
};

export default Roster;
